export function registerHeaderMenu(Alpine) {
    Alpine.data('headerMenu', () => ({
        open: false,
        megaOpen: false,
        hidden: false,
        _lastY: 0,
        _ticking: false,

        init() {
            this._lastY = window.scrollY;
            this._onScroll = () => {
                if (!this._ticking) {
                    this._ticking = true;
                    requestAnimationFrame(() => {
                        this._updateScroll();
                        this._ticking = false;
                    });
                }
            };
            window.addEventListener('scroll', this._onScroll, { passive: true });
        },

        destroy() {
            window.removeEventListener('scroll', this._onScroll);
        },

        _updateScroll() {
            const y = window.scrollY;
            const delta = y - this._lastY;

            // Don't hide when menu/drawer is open or near the top
            if (this.open || this.megaOpen || y < 80) {
                this.hidden = false;
                this._lastY = y;
                this._syncHeaderOffset();
                return;
            }

            // Dead zone to avoid flickering on small scrolls
            if (Math.abs(delta) < 5) return;

            this.hidden = delta > 0; // scrolling down → hide
            this._lastY = y;
            this._syncHeaderOffset();
        },

        _syncHeaderOffset() {
            const el = document.documentElement;
            if (this.hidden) {
                el.style.setProperty('--ik-header-visible-height', '0px');
            } else {
                el.style.removeProperty('--ik-header-visible-height');
            }
        },

        toggle() { this.open = !this.open },
        close()  { this.open = false },
        toggleMega() { this.megaOpen = !this.megaOpen },
        closeMega()  { this.megaOpen = false },
    }));
}
